// discount-drawer.js — Apply / remove discount codes depuis le drawer (robuste aux re-render)
(() => {
  const ROOT    = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  const JSON_HEADERS = { 'Content-Type':'application/json', 'Accept':'application/json' };
  const FORM_HEADERS = { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8', 'Accept':'application/json' };

  // --- Ajax helpers
  const cartGet = () => fetch(ROOT + 'cart.js', { credentials:'same-origin' }).then(r => r.json());

  async function applyCodes(csv) {
    // 1) voie officielle (JSON)
    let res = await fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
      body: JSON.stringify({ discount: csv })
    });
    if (res.ok) return true;

    // 2) fallback (form-encoded) — certains setups l’exigent
    res = await fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: FORM_HEADERS, credentials: 'same-origin',
      body: 'discount=' + encodeURIComponent(csv)
    });
    if (res.ok) return true;

    // 3) dernier recours: endpoint /discount/CODE (applique le code côté serveur)
    await fetch(`${ROOT}discount/${encodeURIComponent(csv)}?redirect=/cart`, { credentials: 'same-origin' });
    return true;
  }

  async function clearCodes() {
    // même logique avec une valeur vide
    let res = await fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: JSON_HEADERS, credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    });
    if (res.ok) return true;

    res = await fetch(ROOT + 'cart/update.js', {
      method: 'POST', headers: FORM_HEADERS, credentials: 'same-origin',
      body: 'discount='
    });
    if (res.ok) return true;

    // certains shops acceptent /discount/clear
    await fetch(`${ROOT}discount/clear?redirect=/cart`, { credentials: 'same-origin' });
    return true;
  }

  // --- Refresh UI (Focal + Section Rendering API)
  function sectionIds() {
    const ids = [];
    const drawer = document.querySelector('cart-drawer');
    const sid = drawer?.dataset?.sectionId;
    if (sid) ids.push(sid);                       // id réel de la section mini-cart
    if (document.getElementById('shopify-section-cart-icon-bubble') ||
        document.querySelector('[data-section-id="cart-icon-bubble"]')) {
      ids.push('cart-icon-bubble');
    }
    return ids;
  }

  async function refreshDrawer() {
    // 1) hook Maestrooo
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    // 2) fallback Section Rendering API
    const ids = sectionIds();
    if (!ids.length) return;
    try {
      const res = await fetch(`${ROOT}?sections=${ids.join(',')}`, { credentials: 'same-origin' });
      if (!res.ok) return;
      const html = await res.json();
      ids.forEach(id => {
        const el = document.getElementById('shopify-section-' + id) ||
                   document.querySelector(`[data-section-id="${id}"]`);
        if (el && html[id]) el.innerHTML = html[id];
      });
    } catch (_) {}
  }

  // --- Utils
  function codesFromCart(cart) {
    const set = new Set();
    (cart.cart_level_discount_applications || []).forEach(a => {
      const t = (a.title || '').toUpperCase(); if (t) set.add(t);
    });
    // si vous voulez ignorer les remises de ligne, vous pouvez retirer ce bloc
    (cart.items || []).forEach(li => {
      (li.line_level_discount_allocations || []).forEach(alloc => {
        const t = (alloc.discount_application?.title || '').toUpperCase(); if (t) set.add(t);
      });
    });
    return Array.from(set);
  }

  function feedback(text, ok = true) {
    const p = document.getElementById('drawer-discount-feedback');
    if (!p) return;
    p.textContent = text || '';
    p.style.color = ok ? 'inherit' : '#b42318';
  }

  // --- APPLY (submit) — handler délégué (survive aux re-render)
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('#drawer-discount-form');
    if (!form) return;
    e.preventDefault();

    const input = form.querySelector('#drawer-discount-input');
    const code  = (input?.value || '').trim();
    const tCode    = form?.dataset?.i18nCode    || 'Discount code';
    const tApplied = form?.dataset?.i18nApplied || 'Code applied';
    const tInvalid = form?.dataset?.i18nInvalid || 'Invalid or non-stackable code';

    if (!code) { feedback(`${tCode}?`, false); return; }

    try {
      await applyCodes(code);                 // applique (avec fallbacks)
      const cart = await cartGet();          // revalide côté client
      const applied = codesFromCart(cart).includes(code.toUpperCase());
      feedback(applied ? `${tApplied} ✔` : tInvalid, applied);
      if (applied && input) input.value = '';
      await refreshDrawer();
    } catch (err) {
      console.warn('[discount-drawer] apply error', err);
      feedback('Oops. Try again.', false);
    }
  });

  // --- REMOVE (croix ✕) — handler délégué
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-action="remove-discount"]');
    if (!btn) return;
    const codeToRemove = (btn.dataset.code || '').toUpperCase();
    try {
      const cart = await cartGet();
      const keep = codesFromCart(cart).filter(c => c !== codeToRemove);
      if (keep.length) { await applyCodes(keep.join(',')); }
      else { await clearCodes(); }
      await refreshDrawer();
    } catch (err) {
      console.warn('[discount-drawer] remove error', err);
    }
  });
})();
